import React from 'react';
import {
  Routes,
  Route,
  Link as RRLink,
  useResolvedPath,
  createPath,
} from 'react-router-dom';

import routes from './routes.json';
import FrontPage from './p/Frontpage/FrontPage';
import { SafeRoute } from './c/SafeRoute';
import { LL, getPathPrefix } from './c/LL';
import NotFound from './c/NotFound';

import PrivacyPage from './p/PrivacyPage'
import TermsOfUse from './p/TermsOfUse'
import LoginPage from './p/Login/LoginPage'
import WhistlePage from './p/WhistlePage/WhistlePage'
import CreateWhistlePage from './p/CreateWhistle/CreateWhistlePage'
import DashboardPage from './p/Dashboard/DashboardPage'
import CreatePasswordPage from './p/Login/CreatePasswordPage'
import { CURRENT_LANG, DEFAULT_LANGUAGE, languages } from './config';

const components = {
  LoginPage,
  FrontPage,
  CreateWhistlePage,
  WhistlePage,
  DashboardPage,
  CreatePasswordPage,
  PrivacyPage,
  TermsOfUse,
};

const SibilusRoutes = () => {
  const get_component = (r) => {
    let C = components[r.component];
    if (C === undefined){
      throw new Error(
        'component defined in routes.json but does not exist locally: ' +
        r.component +
        ' for route "' +
        r.route +
        '"'
      );
    }
    if (r["loginRequired"] === true) {
      return (
        <SafeRoute>
          <C />
        </SafeRoute>
      )
    }

    return (
      <C />
		)
	};
	let rs = [];
	for (const route of routes) {
		for (const language of languages) {
			const key = language + ':' + route.route;
			let path = getPathPrefix() +  language + route.route;
			if(language === DEFAULT_LANGUAGE){
				path = getPathPrefix() + route.route
			}
			rs.push(<Route key={key} path={path} element={get_component(route)} />);
		}
	}
	rs.push(<Route key={"notfound"} path={"*"} element={<NotFound />} />);
	return (
		<Routes>
			{rs}
		</Routes>
	)
};

const get_path_array = () => {
  // react-router-dom has `useLocation`, which ostensibly does the same
  // as `window.location`, but has these weird React-hook requirements
  // that make them unusable outside of components, so here's some really
  // old fashioned JS for you!
  return window.location.pathname.split('/').slice(1);
};


const Link = (props) => {
  const path = LL(createPath(useResolvedPath(props.to)));
  const pprops = { ...props, to: undefined, children: undefined };
  return (
    <RRLink {...pprops} to={path}>
      {props.children}
    </RRLink>
  );
};

const goto_language = (lang) => {
  if (lang === CURRENT_LANG) return;
  let xs = get_path_array();
  xs[0] = lang;
  window.location.pathname = xs.join('/');
};

export { SibilusRoutes, Link, goto_language };
